import {
  getUserBillingStatus,
  getUserVerificationStatus,
} from "@utils/accessChecks";
import { useSession } from "next-auth/react";
import NoAccess from "./NoAccess";
import NotVerified from "./NotVerified";
import PaymentError from "./PaymentError";

export default function NoAccessPlaceholder() {
  const { data: session } = useSession();
  if (!session) {
    return <NoAccess />;
  }
  if (!getUserVerificationStatus(session)) {
    return <NotVerified />;
  } else if (
    getUserBillingStatus(session) !== "Paid"
  ) {
    return <PaymentError/>;
  }
  // school stuff not yet build
  // else if (getUserSchoolSetupStatus(session)) {
  //   return <SchoolSetupPending />;
  // }
  else return <NoAccess />;
}
